/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：285__part-13
 */

"use strict"

import * as /* [auto-meaningful-name] */Module_924 from /* 924 */"../../224/924/index"
var vn = "-ant-".concat(Date.now(), "-").concat(Math.random())
export { vn }
